import React, { useState, useEffect } from 'react';
import Dashboard from '../components/Dashboard';
import { useAuth } from '../contexts/AuthContext';
import apiService from '../services/api';

const DashboardPage = () => {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        
        // Only fetch users data if current user is admin
        const isAdmin = user?.isAdmin || user?.role === 'admin';
        
        if (isAdmin) {
          // Fetch users and leads in parallel for admin users
          const [usersResponse, leadsResponse] = await Promise.all([
            apiService.getAllUsers(),
            apiService.getAllLeads({ limit: 1000 }) // Get all leads for accurate stats
          ]);

          setUsers(usersResponse || []);
          setLeads(leadsResponse.leads || []);
        } else {
          // For regular users, only fetch leads data
          const leadsResponse = await apiService.getAllLeads({ limit: 1000 });
          setUsers([]); // Empty array for non-admin users
          setLeads(leadsResponse.leads || []);
        }
      } catch (error) {
        console.error('Failed to fetch dashboard data:', error);
        setError(error.message || 'Failed to fetch dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [user]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#718096',
        background: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '16px',
        padding: '40px',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        Loading dashboard data...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#e53e3e',
        background: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '16px',
        padding: '40px',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        Error: {error}
      </div>
    );
  }

  return <Dashboard users={users} leads={leads} currentUser={user} />;
};

export default DashboardPage; 